import { ReactNode } from 'react';

type SpacingDimension = 'sm' | 'base' | 'md' | 'lg' | 'auto';
type LayoutDimension = '1/2' | '1/3' | '2/3' | 'full' | number;

type ContainerProps = {
  children?: ReactNode;
  onClick?: Function;
  extensions?: string;
  // mt?: SpacingDimension;
  // mb?: SpacingDimension;
  // my?: SpacingDimension;
  // mx?: SpacingDimension;
  // ml?: SpacingDimension;
  // mr?: SpacingDimension;
  // pt?: SpacingDimension;
  // pb?: SpacingDimension;
  // py?: SpacingDimension;
  // px?: SpacingDimension;
  // pl?: SpacingDimension;
  // pr?: SpacingDimension;
  width?: string;
  height?: string;
  mt?: string;
  bgColor?: string;
  borderX?: string;
  borderL?: string;
  borderR?: string;
  borderY?: string;
  borderT?: string;
  borderB?: string;
};

export default function Container(props: ContainerProps) {
  const { children, ...rest } = props;
  // this needs a lot of work
  return (
    <div
      onClick={() => props.onClick && props.onClick()}
      className={props.extensions}
    >
      {children}
    </div>
  );
}
